import React from 'react';
import { StatusIndicator } from '../../components/StatusIndicator/StatusIndicator';

/**
 * ProjectStatusBadge — statut d'un projet en « ● Label ».
 *
 * Même grammaire visuelle qu'ArticleStatusBadge, mais sur l'énum ProjectStatus
 * (pas de SCHEDULED côté projets : la mise en ligne se pilote à la date de
 * publication, sans statut intermédiaire).
 */

const STATUS_MAP = {
  PUBLISHED: { tone: 'ink',   label: 'Publié' },
  DRAFT:     { tone: 'faded', label: 'Brouillon' },
  ARCHIVED:  { tone: 'muted', label: 'Archivé' },
};

export const PROJECT_STATUS_LABELS = Object.fromEntries(
  Object.entries(STATUS_MAP).map(([key, cfg]) => [key, cfg.label]),
);

export function ProjectStatusBadge({ status, size = 'md', uppercase = false, className }) {
  const cfg = STATUS_MAP[status] || STATUS_MAP.DRAFT;
  return (
    <StatusIndicator tone={cfg.tone} size={size} uppercase={uppercase} className={className}>
      {cfg.label}
    </StatusIndicator>
  );
}

export default ProjectStatusBadge;
